import { useQuery } from '@tanstack/react-query';

import { getCompetitionStructureQuery } from '@shared/queries/competition';
import { RoundPhase } from '@shared-types/match.types';

export function useCompetitionStructure(competitionId: string, seasonYear: string) {
  const { data: compStr, isFetched } = useQuery(
    getCompetitionStructureQuery({
      competitionId,
      seasonYears: seasonYear,
      phase: RoundPhase.TOURNAMENT,
    }),
  );

  const { rounds, matchdays } = compStr ?? {};

  return { rounds, matchdays, isFetched };
}
